'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { FiGlobe } from 'react-icons/fi';

export default function LanguageToggle() {
  const pathname = usePathname();

  if (!pathname) return null;

  const isPortuguese = pathname.endsWith('/pt');
  const basePath = isPortuguese ? pathname.replace(/\/pt$/, '') : pathname;

  return (
    <div className="absolute top-2 right-6 flex gap-2 items-center">
      <FiGlobe className="text-gray-700" size={18} />
      {!isPortuguese && (
        <Link
          href={`${basePath}/pt`}
          className="text-xs md:text-sm font-medium border px-3 py-1 rounded hover:bg-gray-100"
        >
          PT
        </Link>
      )}
      {isPortuguese && (
        <Link
          href={basePath}
          className="text-xs md:text font-medium border px-3 py-1 rounded hover:bg-gray-100"
        >
          DE
        </Link>
      )}
    </div>
  );
}
